"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSafeTransactionInfo = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const chain_adapters_1 = require("@shapeshiftoss/chain-adapters");
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("./constants");
const nilSafeTransctionInfo = {
    transaction: null,
    isSafeTxHash: false,
    isQueuedSafeTx: false,
    isExecutedSafeTx: false,
};
const fetchSafeTransactionInfo = async ({ safeTxHash, accountId, fetchIsSmartContractAddressQuery, }) => {
    const chainId = accountId ? (0, caip_1.fromAccountId)(accountId).chainId : '';
    if (!accountId || !chainId || !(0, chain_adapters_1.isEvmChainId)(chainId))
        return nilSafeTransctionInfo;
    const isSmartContractAddress = await fetchIsSmartContractAddressQuery((0, caip_1.fromAccountId)(accountId).account, chainId);
    if (!isSmartContractAddress) {
        // Assume any smart contract address is a SAFE, and by extension, any non-smart contract address is not
        // This is super naive, but this is exactly the same way SAFE does it
        // https://github.com/safe-global/safe-core-sdk/blob/ea0d5018a93f294dfd891e6c8963edcb96431876/packages/protocol-kit/src/Safe.ts#L303
        return nilSafeTransctionInfo;
    }
    const baseUrl = constants_1.ChainIdToSafeBaseUrl[chainId];
    if (!baseUrl) {
        throw new Error(`Unsupported chain ID: ${chainId}`);
    }
    try {
        const response = await axios_1.default.get(`${baseUrl}/api/v1/multisig-transactions/${safeTxHash}/`);
        if ('detail' in response.data) {
            return nilSafeTransctionInfo;
        }
        const isQueuedSafeTx = Boolean(!response.data?.transactionHash &&
            response.data?.confirmations &&
            response.data.confirmations.length <= response.data.confirmationsRequired);
        const isExecutedSafeTx = Boolean(response.data?.transactionHash);
        return {
            transaction: response.data,
            isSafeTxHash: true,
            isQueuedSafeTx,
            isExecutedSafeTx,
        };
    }
    catch (error) {
        // If the request fails, it's likely not a Safe transaction hash
        return nilSafeTransctionInfo;
    }
};
exports.fetchSafeTransactionInfo = fetchSafeTransactionInfo;
__exportStar(require("./types"), exports);
